module.exports = __webpack_public_path__ + "img/14.86f8f20d.jpg";